import { composeIO } from 'react-compose-io'
import { cabecalhoListaParceirosIO } from './CabecalhoListaParceiros.IO'
import { CabecalhoListaParceirosView } from './CabecalhoListaParceiros.View'

export const CabecalhoListaParceiros = composeIO(CabecalhoListaParceirosView, cabecalhoListaParceirosIO)
